module.exports = __webpack_public_path__ + "static/media/back_login.51b5c4da.svg";